import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

function connectToSocket() {
    const token = localStorage.getItem("token");
    const backend = new URL(getBackendUrl());
    const basePath = backend.pathname.replace(/\/$/, "");
    return openSocket(backend.origin, {
      path: `${basePath}/socket.io`,
      transports: ["websocket", "polling"],
      query: {
        token: JSON.parse(token),
      },
    });
}

export default connectToSocket;
